import axios from 'axios'
import store from '@/store'
import { print } from 'graphql'

export const service = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
})

// helium request can be canceled, and gets cached in store
const defaultQLOptions = {
  maxAge: null,
  disableCache: false,
}
export function cancelableApiQL(gquery, variables, inputOptions = {}) {
  const options = { ...defaultQLOptions, ...inputOptions }

  if (!options.disableCache) {
    const { cached } = store.getters.queryCache(gquery, variables, options)
    if (cached) {
      // check if helium is promisepending, so we can wait for it
      if (cached.isHeliumPromisePending) {
        return cached
      } else {
        return {
          // cached response which is not promise is not cancelable
          cancel: () => {},
          response: Promise.resolve({ data: cached }),
        }
      }
    }
  }

  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const post = service.post(
    '',
    {
      query: print(gquery),
      variables,
    },
    { cancelToken: source.token }
  )
  const ret = {
    cancel: () => {
      source.cancel('Operation canceled by the user.')
    },
    response: post,
  }

  if (!options.disableCache) {
    // also set cache to post
    post
      .then(async (response) => {
        // we replace the promise with the actual data
        store.dispatch('setQueryCache', {
          gquery,
          variables,
          data: response.data,
        })
      })
      .catch(() => {
        // delete the cached promise from the state on error
        const { id } = store.getters.queryCache(gquery, variables, options)
        store.commit('CLEAR_CACHE', { ids: [id] })
      })

    // put the promise in the store, so we can wait for it
    store.dispatch('setQueryCache', {
      gquery,
      variables,
      data: {
        isHeliumPromisePending: true,
        ...ret,
      },
    })
  }

  return ret
}

// this is now a wrapper function for the async cancelable,
// cannot be cancelled, but has a required check

const defaultOptions = {
  ...defaultQLOptions,
  required: true,
  message: 'No result found.',
}

export async function apiQL(query, variables, inputOptions = {}) {
  const options = { ...defaultOptions, ...inputOptions }
  const response = await cancelableApiQL(query, variables, options).response

  // check if it is required
  if (options.required) {
    for (const data of Object.values(response.data)) {
      for (const point of Object.values(data)) {
        if (!point) throw new Error(options.message)
      }
    }
  }
  return response.data
}
